<h2 id="select-tmpl-title">{{ 'esploro.research.cv.page.template.title' | translate }}</h2>
@if (loading()) {
  <mulo-loading-slate></mulo-loading-slate>
}
<div [formGroup]="form">
  <p>
    <em class="info-text">{{ 'esploro.research.cv.page.template.info.message.1' | translate }}</em>
    <mat-list
      role="list"
      class="mulo-elevation-list margin-top-sm margin-bottom-md"
      aria-labelledby="select-tmpl-title"
      >
      @for (template of otbTemplates(); track template; let i = $index) {
        <mulo-action-list-item
          role="listitem"
          class="mulo-elevation-list-item"
          exlDescriptionA11y="name-item-{{ i }}"
          [moreBtnLabel]="'research.aria.output.list.menu.more.options' | translate"
          >
          @if (template.name | translateObject; as templateName) {
            <mat-radio-button
              [value]="template.id"
              [checked]="templateId() === template.id"
              (change)="onTemplateSelectionChange($event.value)"
              >
              <span class="template-details template-name">{{ templateName }}</span>
            </mat-radio-button>
          }
        </mulo-action-list-item>
      }
      @for (template of userTemplates(); track template; let i = $index) {
        @if (template.name | translateObject; as templateName) {
          <mulo-action-list-item
            role="listitem"
            class="mulo-elevation-list-item"
            exlDescriptionA11y="name-item-{{ i + otbTemplates().length }}"
            [moreBtnLabel]="'research.aria.output.list.menu.more.options' | translate"
            >
            <mat-radio-button
              [value]="template.id"
              [checked]="templateId() === template.id"
              (change)="onTemplateSelectionChange($event.value)"
              >
              <span class="template-details">
                <span class="template-name">{{ templateName }}</span>
                @if (template.createDate) {
                  <span class="info-text"
                    >{{ 'research.date.date.created.default.default' | translate }}:
                    {{ template.createDate | date : systemDateSvc.ngDateFormat }}</span
                    >
                  }
                </span>
              </mat-radio-button>
              <mulo-action-list-item-action
                type="icon-btn"
                [icon]="media.is('gt-sm') ? 'close' : null"
                [labels]="['research.delete.confirmation.confirm' | translate]"
                (actionEvent)="showRemoveConfirmationDialog(i, templateName)"
              ></mulo-action-list-item-action>
            </mulo-action-list-item>
          }
        }
      </mat-list>
    </p>
  </div>
  <div class="next-btn-wrap">
    <button (click)="nextStep.emit()" mat-flat-button color="primary" class="padding-right-xs">
      <div class="next-btn-content">
        {{ 'esploro.research.cv.page.button.next' | translate }}
        <mat-icon class="mat-icon-rtl-mirror" svgIcon="chevron-right"></mat-icon>
      </div>
    </button>
  </div>
